import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef
} from '@angular/core';
import { HistoricalChartComponent } from 'app/charts-dashboard/components/charts/historical-chart/historical-chart.component';
import { ChartsCommonService } from 'app/charts-dashboard/services/charts-common.service';
import { ChartsDashboardQuery } from 'app/charts-dashboard/state/dashboard';
import {
  ChartsDashboardSeriesQuery,
  IChartSeries
} from 'app/charts-dashboard/state/series';
import { ChartsDashboardCardQuery } from 'app/charts-dashboard/state/card';
import { ChartsHttpService } from 'app/charts-dashboard/services/charts-http.service';
import { Observable } from 'rxjs';
import {
  AxisXHistorical,
  ChartFilterPatternNameEnum,
  Datetime,
  IChartFilter,
  IChartPointsResponse,
  IMappedSeriesPointsResponse,
  ITotalOpenInterestVolumeChartParameters,
  Point,
  CustomControlsNameEnum,
  TotalOIEnum
} from 'app/charts-dashboard/interfaces';
import { map } from 'rxjs/operators';
import { CommonService } from 'app/core/services/common.service';
import {
  LineSeries,
  SeriesXY,
} from '@arction/lcjs';
import { ChartsDashboardStateService } from 'app/charts-dashboard/state/charts-dashboard-state.service';

@Component({
  selector: 'iv-live-total-oi-chart',
  templateUrl: '../common-chart/common-chart.component.html',
  styleUrls: ['../common-chart/common-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TotalOiChartComponent extends HistoricalChartComponent {

  constructor(
    protected readonly commonService: CommonService,
    protected readonly chartsCommonService: ChartsCommonService,
    protected readonly elementRef: ElementRef,
    protected readonly changeDetectorRef: ChangeDetectorRef,
    protected readonly dashboardQuery: ChartsDashboardQuery,
    protected readonly seriesQuery: ChartsDashboardSeriesQuery,
    protected readonly cardsQuery: ChartsDashboardCardQuery,
    protected readonly httpService: ChartsHttpService,
    protected readonly chartsState: ChartsDashboardStateService
  ) {
    super(commonService, chartsCommonService, elementRef, changeDetectorRef, dashboardQuery, seriesQuery, cardsQuery, httpService, chartsState);
  }

  private static rearrangeYZPoints(points:  Point<AxisXHistorical>[]): Point<AxisXHistorical>[] {
    return points.map((point: Point<AxisXHistorical>) => {
      return {
        ...point,
        y: point.z,
        z: point.y
      };
    });
  }

  protected setCursorResultTableFormatter(lineSeries: LineSeries, series: IChartSeries, filters?: IChartFilter[]): void {
    lineSeries
      .setCursorResultTableFormatter((builder, _series: SeriesXY, x: number, y: number) => {
        this.builderCursorResult = builder;
        this.builderCursorResult
          .addRow(`${this.cursorResult.x === 'Date' ? '' : this.cursorResult.x} ${_series.axisX.formatValue(x).substring(0,10)}`.replace(',', ''))
          .addRow(`${series.stock.symbol}`)
          .addRow(`${series.selectedFilters[CustomControlsNameEnum.TOTAL_OI_CHART_TYPE].name === TotalOIEnum.OPEN_INTEREST ? this.cursorResult.y : this.cursorResult.z}: ${Math.round((y + Number.EPSILON) * 100) / 100}`)
          .addRow(`Option Type: ${series.selectedFilters[ChartFilterPatternNameEnum.OPTION_TYPE].description}`);

        return this.builderCursorResult;
      });
  }

  protected fillLineSeries(pointsData: IMappedSeriesPointsResponse<AxisXHistorical>, isMainSeries: boolean): void {
    if (this.seriesQuery.getEntity(pointsData.seriesId).selectedFilters.totalOiChartType.name === TotalOIEnum.VOLUME) {
      super.fillLineSeries({...pointsData, points: TotalOiChartComponent.rearrangeYZPoints(pointsData.points)}, isMainSeries);
      return;
    }

    super.fillLineSeries(pointsData, isMainSeries);
  }

  protected createSeriesObservables(seriesArr: IChartSeries[], isFirstLoad?: boolean): Observable<IMappedSeriesPointsResponse<AxisXHistorical>>[] {
    return seriesArr.map((series: IChartSeries) => {
      return this.httpService.getTotalOpenInterestVolume(this.getChartsParams(series, isFirstLoad) as ITotalOpenInterestVolumeChartParameters)
        .pipe(map((data: IChartPointsResponse<AxisXHistorical>) => {
          return {
            ...data,
            seriesId: series.id
          };
        }));
    });
  }

  protected getChartsParams(series: IChartSeries, isFirstLoad?: boolean): ITotalOpenInterestVolumeChartParameters {
    if (!series) return;

    let from: Datetime;

    if (!isFirstLoad) {
      from = this.getFrom(series);
    }

    return {
      stockId: series.stock.stockId.toString(),
      symbol: series.stock.symbol,
      from,
      timeRange: series.selectedFilters.eodTimeRange.name,
      optionType: series.selectedFilters.optionType.name,
      sendUserMetrics: !this.isSentUserMetrics && this.mainSeries.id === series.id
    };
  }
}
